/** Styl radiobutonu k tématu Erma */
export const RadioButtonStyles = {
  root: {
    width: "18px",
    height: "18px",
    background: "var(--erma-secondary-0)",
    checkedBackground: "var(--erma-primary-700)",
    checkedHoverBackground: "var(--erma-primary-500)",
    disabledBackground: "var(--erma-secondary-40)",
    filledBackground: "var(--erma-primary-0)",
    borderColor: "var(--erma-secondary-220)",
    hoverBorderColor: "var(--erma-secondary-300)",
    focusBorderColor: "var(--erma-primary-400)",
    checkedBorderColor: "var(--erma-primary-500)",
    checkedHoverBorderColor: "var(--erma-primary-300)",
    checkedFocusBorderColor: "var(--erma-primary-400)",
    checkedDisabledBorderColor: "var(--erma-primary-50)",
    invalidBorderColor: "#a94442",
    focusRing: {
      width: "0",
      style: "none",
      color: "unset",
      offset: "0",
      shadow: "none"
    },
    transitionDuration: "1s",
    sm: {
      width: "16px",
      height: "16px"
    },
    lg: {
      width: "24px",
      height: "24px"
    }
  },
  icon: {
    size: "10px",
    checkedColor: 'var(--erma-primary-0)',
    checkedHoverColor: 'var(--erma-primary-0)',
    disabledColor: "var(--erma-secondary-30)",
    sm: {
      size: "8px"
    },
    lg: {
      size: "12px"
    }
  },
  css: ({ dt }) => `
.p-radiobutton {
    border-radius: 50%;
    transition: box-shadow ${dt("radiobutton.transition.duration")};
}

.p-radiobutton-box {
    border-width: 2px;
}

.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, ${dt("text.color")}, transparent 96%);
}

.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, ${dt("text.color")}, transparent 88%);
}

.p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:hover) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, ${dt("radiobutton.checked.border.color")}, transparent 92%);
}

.p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:focus-visible) {
    box-shadow: 0 0 1px 10px color-mix(in srgb, ${dt("radiobutton.checked.border.color")}, transparent 84%);
}
`
};
